import { useCallback, useEffect } from 'react'
import {
  selectTaskTrackerBoardFilterStickers,
  selectTaskTrackerBoardFilterStickersReloadToken,
} from '../../store/taskTracker.selectors'
import { useTaskTrackerDispatch, useTaskTrackerSelector } from '../../store/taskTracker.hooks'
import { fetchBoardFilterStickersThunk } from '../../store/taskTracker.thunks'

export type { TaskTrackerBoardFilterStickerRow } from '../../store/taskTracker.types'

type LoadBoardFilterStickersOptions = {
  silent?: boolean
}

export const useTaskTrackerBoardFilterStickers = (boardId: number | null) => {
  const dispatch = useTaskTrackerDispatch()
  const { rows, loading, error, isInitialized } = useTaskTrackerSelector((state) =>
    selectTaskTrackerBoardFilterStickers(state, boardId),
  )
  const filterStickersReloadToken = useTaskTrackerSelector((state) =>
    selectTaskTrackerBoardFilterStickersReloadToken(state, boardId),
  )

  const load = useCallback(
    (options?: LoadBoardFilterStickersOptions) => {
      if (boardId == null) return
      void dispatch(
        fetchBoardFilterStickersThunk({
          boardId,
          silent: options?.silent,
        }),
      )
    },
    [boardId, dispatch],
  )

  useEffect(() => {
    if (boardId == null || isInitialized || loading) return
    load()
  }, [boardId, isInitialized, load, loading])

  useEffect(() => {
    if (boardId == null || filterStickersReloadToken === 0) return
    load({ silent: true })
  }, [boardId, filterStickersReloadToken, load])

  const hasFilterableStickers = rows.length > 0

  return {
    rows,
    loading,
    error,
    hasFilterableStickers,
    reload: load,
  }
}
